import { EventType } from '@wix/public-editor-platform-interfaces';
import {
  IPlatformHostEvent,
  PlatformPrivateEvent,
  PlatformPrivateEventEmitter,
} from './PlatformPrivateEventEmitter';

/**
 * The events bridge between DM and private events
 */
export class DMEventsBridge {
  static allowedEvents = [
    EventType.componentSelectionChanged,
    EventType.appInstalled,
    EventType.appUpdateCompleted,
    EventType.removeAppCompleted,
  ];

  private mapToPlatformHostEvent(event: any): IPlatformHostEvent {
    if (typeof event === 'string') {
      try {
        event = JSON.parse(event);
      } catch (e) {
        // TODO: log error
      }
    }

    return {
      type: PlatformPrivateEvent.HostEvent,
      payload: {
        type: event.args.eventType,
        ...event.args.eventPayload,
      },
      meta: {
        appDefinitionId: event.appDefinitionId ?? null,
        intent: event.intent,
      },
    };
  }

  constructor(private events: PlatformPrivateEventEmitter) {}

  /**
   * Notify by event from Worker Manager (platform infrastructure)
   */
  public notify(_event: any) {
    const event = this.mapToPlatformHostEvent(_event);
    if (
      DMEventsBridge.allowedEvents.includes(event.payload.type as EventType)
    ) {
      this.events.notify(event);
    }
  }
}
